import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import styles from './ConfigSections.module.css'

type SectionHeaderProps = {
  title?: ReactNode
  titleAction?: ReactNode
  subtitle: ReactNode
  action?: ReactNode
  hideTitleRow?: boolean
}

export function SectionHeader({title, titleAction, subtitle, action, hideTitleRow}: SectionHeaderProps) {
  return (
    <div className={clsx(styles.sectionHeaderRow, hideTitleRow && styles.sectionHeaderRowNoTitle)}>
      {!hideTitleRow && title != null && (
        <div className={styles.titleArea}>
          <h3 className={styles.sectionTitle}>{title}</h3>
          {titleAction}
        </div>
      )}
      <div className={styles.descriptionArea}>
        <p className={styles.sectionSubtitle}>{subtitle}</p>
      </div>
      {action != null && <div className={styles.action}>{action}</div>}
    </div>
  )
}
